import { render, staticRenderFns } from "./ReviewsItem.vue?vue&type=template&id=4465b874&scoped=true&"
import script from "./ReviewsItem.vue?vue&type=script&lang=ts&"
export * from "./ReviewsItem.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewsItem.vue?vue&type=style&index=0&id=4465b874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465b874",
  null
  
)

export default component.exports